/** Inline stroke icons. No icon dependency, inherits currentColor. */
import React from 'react';

const base = {
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.75,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': 'true',
    focusable: 'false',
};

const make = (name, children) => {
    const Icon = props => (
        <svg {...base} {...props}>
            {children}
        </svg>
    );
    Icon.displayName = name;
    return Icon;
};

export const LifeBuoy = make('LifeBuoy', (
    <>
        <circle cx="12" cy="12" r="9" />
        <circle cx="12" cy="12" r="3.6" />
        <path d="m14.6 9.4 3.2-3.2M6.2 17.8l3.2-3.2M14.6 14.6l3.2 3.2M6.2 6.2l3.2 3.2" />
    </>
));

export const Mail = make('Mail', (
    <>
        <rect x="2.5" y="4.5" width="19" height="15" rx="3" />
        <path d="m3.5 7 7.3 5.2a2 2 0 0 0 2.4 0L20.5 7" />
    </>
));

export const ArrowRight = make('ArrowRight', <path d="M4 12h15m0 0-5.5-5.5M19 12l-5.5 5.5" />);

export const ArrowLeft = make('ArrowLeft', <path d="M20 12H5m0 0 5.5-5.5M5 12l5.5 5.5" />);

export const ChevronRight = make('ChevronRight', <path d="m9.5 5.5 6.5 6.5-6.5 6.5" />);

export const Search = make('Search', (
    <>
        <circle cx="10.75" cy="10.75" r="6.75" />
        <path d="m15.8 15.8 4.2 4.2" />
    </>
));

export const Sun = make('Sun', (
    <>
        <circle cx="12" cy="12" r="4.2" />
        <path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M18.7 5.3l-1.4 1.4M6.7 17.3l-1.4 1.4" />
    </>
));

export const Moon = make('Moon', <path d="M20.5 14.4A8.6 8.6 0 0 1 9.6 3.5a8.7 8.7 0 1 0 10.9 10.9Z" />);

export const ShieldCheck = make('ShieldCheck', (
    <>
        <path d="M12 2.75 4.75 5.8v5.6c0 4.4 3 8.4 7.25 9.85 4.25-1.45 7.25-5.45 7.25-9.85V5.8Z" />
        <path d="m9 12 2.1 2.1L15.4 9.8" />
    </>
));

export const Check = make('Check', <path d="m4.5 12.5 5 5 10-11" />);

export const Info = make('Info', (
    <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v5.5M12 7.6v.6" />
    </>
));

export const Alert = make('Alert', (
    <>
        <path d="M10.3 3.9 2.5 17.5A2 2 0 0 0 4.2 20.5h15.6a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
        <path d="M12 9v4.2M12 16.6v.5" />
    </>
));

export const Clock = make('Clock', (
    <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 6.8V12l3.4 2" />
    </>
));

export const Sparkle = make('Sparkle', (
    <path d="M12 3.2 13.8 9 19.6 10.8 13.8 12.6 12 18.4 10.2 12.6 4.4 10.8 10.2 9Z" />
));

export const Compass = make('Compass', (
    <>
        <circle cx="12" cy="12" r="9" />
        <path d="m15.2 8.8-1.8 4.6-4.6 1.8 1.8-4.6Z" />
    </>
));

export const Apple = props => (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" {...props}>
        <path d="M16.4 12.7c0-2.3 1.9-3.4 2-3.5-1.1-1.6-2.8-1.8-3.4-1.9-1.4-.1-2.8.9-3.5.9-.7 0-1.9-.9-3.1-.8-1.6 0-3 .9-3.8 2.4-1.6 2.8-.4 7 1.2 9.3.8 1.1 1.7 2.4 2.9 2.3 1.2 0 1.6-.7 3-.7s1.8.7 3 .7c1.3 0 2.1-1.1 2.9-2.3.9-1.3 1.3-2.6 1.3-2.6s-2.5-1-2.5-3.8ZM14.2 5.3c.6-.8 1-1.9.9-3-.9 0-2 .6-2.7 1.4-.6.7-1.1 1.8-.9 2.9 1 .1 2-.5 2.7-1.3Z" />
    </svg>
);

export const Palette = make('Palette', (
    <>
        <path d="M12 3.2a8.8 8.8 0 0 0 0 17.6c1.3 0 2.1-.9 2.1-2 0-.6-.2-1-.6-1.4-.3-.4-.5-.8-.5-1.3 0-1 .8-1.8 1.9-1.8h1.4c2.2 0 3.9-1.7 3.9-4 0-3.9-3.7-7.1-8.2-7.1Z" />
        <circle cx="7.6" cy="11.4" r="1.1" fill="currentColor" stroke="none" />
        <circle cx="10.2" cy="7.4" r="1.1" fill="currentColor" stroke="none" />
        <circle cx="15" cy="8.2" r="1.1" fill="currentColor" stroke="none" />
    </>
));

export const ChevronDown = make('ChevronDown', <path d="m6 9.5 6 6 6-6" />);
